"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientDeclined = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const Dashboard_web_style_1 = require("./Dashboard.web.style");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const PatientDeclined = (props) => {
    const { scrollToAktuel } = props;
    return (react_1.default.createElement(react_native_1.View, { onLayout: event => {
            const layout = event.nativeEvent.layout;
            scrollToAktuel(layout.x, layout.y, layout.width, layout.height / 2, !Breakpoints_1.isMobileOrTablet ? true : false);
        } },
        react_1.default.createElement(react_native_1.Text, { style: [
                Dashboard_web_style_1.styles.heading3,
                !Breakpoints_1.isMobileOrTablet ? {} : GlobalStyles_1.globalStyles.marginTop50,
            ] }, "Ihre Therapie ist unterbrochen"),
        react_1.default.createElement(react_native_1.Text, { style: [Dashboard_web_style_1.styles.text, GlobalStyles_1.globalStyles.marginTop25] }, "Eine Fortsetzung Ihrer Therapie mit nowomed ist derzeit nicht m\u00F6glich."),
        react_1.default.createElement(react_native_1.Text, { style: [
                Dashboard_web_style_1.styles.text,
                GlobalStyles_1.globalStyles.marginTop25,
                !Breakpoints_1.isMobileOrTablet ? {} : Dashboard_web_style_1.styles.paddingHorizontal4pct,
            ] }, "Falls Sie weitere Fragen haben, wenden Sie sich bitte an unseren Support.")));
};
exports.PatientDeclined = PatientDeclined;
